/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts`

const order_accept = {
  namespaced: true,
  actions: {
    /**
     * 受注一覧
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {},

}

export default order_accept
